import React from 'react';
import classNameBind from 'classnames/bind';
import Label from '../../../Label';
import styles from './MenuSection.module.css';
import { MenuElement } from '../MenuElement';

const bindClasses = classNameBind.bind(styles);

const MenuSection = ({
  name,
  sectionId,
  sectionLabel = null,
  sectionItems,
  value,
  dataId,
  disabled = false,
  onChange,
  onBlur,
}) => (
  <div
    id={sectionId}
    className={bindClasses('section')}
    data-ppuc-id={`${dataId}.Section`}
  >
    {sectionLabel && (
      <div className={bindClasses('label')}>
        <Label type="section">{sectionLabel}</Label>
      </div>
    )}
    {sectionItems.map(sectionItem => (
      <MenuElement
        key={sectionItem.id}
        id={sectionItem.id}
        name={name}
        value={sectionItem.value}
        selected={value === sectionItem.value}
        disabled={sectionItem.disabled || disabled}
        onClick={onChange}
        onBlur={onBlur}
        dataId={dataId}
        label={sectionItem.label}
        icon={sectionItem.icon}
        tooltip={sectionItem.tooltip}
        newBadge={sectionItem.newBadge}
      />
    ))}
  </div>
);

export { MenuSection };
